/** Кнопка «назад»: стеклянная пилюля одной высоты с переключателями темы и звука. */

import { motion } from 'framer-motion';

import { IconArrowLeft } from '../icons';

interface BackButtonProps {
  readonly label: string;
  readonly onClick: () => void;
  readonly className?: string;
}

export function BackButton({ label, onClick, className }: BackButtonProps) {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      whileHover={{ x: -2 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: 'spring', stiffness: 520, damping: 34 }}
      className={[
        'glass inline-flex h-11 shrink-0 items-center gap-2 rounded-full border border-line pl-3 pr-4',
        'font-heading text-sm font-semibold text-heading shadow-soft transition-colors hover:border-accent',
        className ?? '',
      ].join(' ')}
    >
      <IconArrowLeft size={18} stroke={2.2} aria-hidden="true" />
      <span>{label}</span>
    </motion.button>
  );
}
